export default __webpack_public_path__ + "static/media/young kim.f4c952af.jpg";